import {PricingStrategy} from '@dms/api/shared';

import {SourcingType} from '../hooks/useSourcingType';

export const PRICING_STRATEGY_OPTIONS: PricingStrategy[] = [
  PricingStrategy.FAIR_PRICE,
  PricingStrategy.LFPP,
];

// TODO(T20-137991): Temporary – LFPP is not calculated for auctions yet. Remove once available.
const AUCTIONS_PRICING_STRATEGY_OPTIONS: PricingStrategy[] = [PricingStrategy.FAIR_PRICE];

export const getPricingStrategyOptions = (sourcingType: SourcingType): PricingStrategy[] =>
  sourcingType === SourcingType.AUCTIONS
    ? AUCTIONS_PRICING_STRATEGY_OPTIONS
    : PRICING_STRATEGY_OPTIONS;
